module.exports = __webpack_public_path__ + "img/wawee-logo-neg-web.939d9bf8.png";